export default __webpack_public_path__ + "static/media/Alfan-Souq-Logo-Design.26afef63.png";